import { Button } from "./buttons"
import Modal from "./modal/Modal";
import React from "react";

function ConfirmDeleteModal({
  showModal,
  onConfirm,
  message,
  onCancel,
  title = "削除の確認",
  buttonConfirmId = "",
}) {
  if (!showModal) {
    return;
  }
  return (
    <div>
      <Modal show={showModal} onClose={onCancel} dismissible size="lg">
        <Modal.Header className=" bg-red-200">{title}</Modal.Header>
        {/* <!--Modal body--> */}
        <Modal.Body className="text-left">
          {message.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Modal.Body>
        <Modal.Footer className="justify-center w-full space-x-[20px]">
          <div className="w-1/2">
            <Button
              type="button"
              color="light"
              className="w-full"
              onClick={onCancel}
            >
              閉じる
            </Button>
          </div>
          <div className="w-1/2">
            <Button
              type="submit"
              color="red"
              className="w-full"
              onClick={onConfirm}
              id={buttonConfirmId}
            >
              適用
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ConfirmDeleteModal;
